// extracted by mini-css-extract-plugin
export default {"wrapper":"BackgroundBorderControl_wrapper__ihuRK","cornersBlock":"BackgroundBorderControl_cornersBlock__kEDG8","bordersWrapper":"BackgroundBorderControl_bordersWrapper__3bRyU"};